import cf from './cf';
import i14v from './i14v_20211024';

export default class i14v1a extends i14v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'i14v1a';
    this.d_viewDefs = {
      name: '設定'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
